var map = {
	"./pig/bagskank-zoomed.svg": 3043,
	"./pig/bov-zoomed.svg": 5108,
	"./pig/bryst-zoomed.svg": 7058,
	"./pig/head-zoomed.svg": 4307,
	"./pig/indmad-zoomed.svg": 4040,
	"./pig/loin-zoomed.svg": 3882,
	"./pig/neck-zoomed.svg": 6117,
	"./pig/skank-zoomed.svg": 2209,
	"./pig/skinke-zoomed.svg": 7966,
	"./pig/tail-zoomed.svg": 5076,
	"./pig/tenderloin-zoomed.svg": 6266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1582;